import { Row } from 'antd';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { UNIT_MEASURE } from '@common/constants';
import formatUOM from '@common/helpers/formatUOM';
import { ChipMinimizerModel } from '@common/models';
import { COMING_SOON_IMAGE } from '@common/utils';
import { formatPriceUnitOrFree } from '@common/utils/formatPriceUnitOrFree';
import ProductCard from '@core/components/ProductCard/ProductCard';
import QuantitySelector from '@core/components/QuantitySelector/QuantitySelector';
import ImageUtils from '@core/utils/ImageUtils';

export interface ChipMinimizerItemProps {
    item: ChipMinimizerModel;
    quantity?: number;
    isSelected?: boolean;
    imgPath?: string;
    hasQuantitySelector?: boolean;
    onClick?: () => void;
    onQuantityChange?: (value: number) => void;
    additionalClasses?: classNames.Mapping;
}

const ChipMinimizerItem = ({
    item,
    quantity = 0,
    isSelected = false,
    imgPath,
    hasQuantitySelector = true,
    onClick,
    onQuantityChange,
    additionalClasses,
}: ChipMinimizerItemProps): JSX.Element => {
    const { t } = useTranslation();
    const description =
        item.price === 0 ? t('SCROLLABLE_AREA.SINK.NO_CHIP_MINIMIZER') : t('SCROLLABLE_AREA.SINK.ADD_CHIP_MINIMIZER');
    const imgSrc = ImageUtils.imgUrl(item.imageUrl || imgPath || COMING_SOON_IMAGE, 300);

    const unitOfMeasure = formatUOM(item.unitOfMeasure || UNIT_MEASURE.CHIP_MINIMIZER);
    return (
        <ProductCard isSelected={isSelected} onClick={onClick} additionalClasses={additionalClasses}>
            <ProductCard.Image src={imgSrc} showSelectedBanner />
            <ProductCard.Title>{description}</ProductCard.Title>
            {Boolean(item.price) && (
                <ProductCard.Subtitle>{formatPriceUnitOrFree(item.price, unitOfMeasure)}</ProductCard.Subtitle>
            )}
            {hasQuantitySelector && isSelected && (
                <Row justify={'center'}>
                    <QuantitySelector
                        value={quantity}
                        min={0}
                        unitOfMeasure={unitOfMeasure}
                        onValueChange={onQuantityChange}
                    />
                </Row>
            )}
        </ProductCard>
    );
};

export default ChipMinimizerItem;
